module.exports = __webpack_public_path__ + "static/plan-creation-view-457c92279f6faea7e538c5fd0e7be193.png";